module.exports = __webpack_public_path__ + "static/media/logos_instagram.5eb8cfba.svg";